var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'color-pick-selectable display-flex justify-content--center align--center':
      _vm.selectable,
    'color-pick': !_vm.selectable,
  },style:({ ..._vm.masterStyles }),on:{"click":_vm.handleClick}},[_c('div',{class:_vm.cssClasses,style:({ backgroundColor: _vm.color, ..._vm.pickStyles })},[(_vm.hasCheck && _vm.isSelected)?_c('a-icon',{staticClass:"pick__icon",attrs:{"type":"check"}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }